import { AfterViewInit, ChangeDetectorRef, Component, effect, Input, OnInit } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { PatientSessionService } from '../patient-session.service';
import { AlarmOption, PatientTargetDataModel, PatientTargetModel, PatientTargetStatus } from '../../../core/api/models';
import { BaseBoxComponent } from '../base-box/base-box.component';
import { AlertService } from '../../../shared/services/alert.service';
@Component({
  selector: 'app-box-toileting',
  templateUrl: './box-toileting.component.html',
  standalone: false,
})
export class BoxToiletingComponent extends BaseBoxComponent implements AfterViewInit, OnInit {
  text: string | undefined = '-';
  expectedAmount: number = 0;
  @Input() isTopBox: boolean = true;
  @Input() isBottomBox: boolean = false;
  @Input() isPreview?: boolean;
  timerInitialValue: number = 60;
  timerValueInput: string = '00:00';
  targetID: number = 0;
  targetData: PatientTargetDataModel[] = [];
  @Input() target: PatientTargetModel | undefined = undefined;



  isStarted: boolean = false;
  timerValue: number = 0;
  private startTime: number = 0;
  toiletings: { urinationOn: boolean; urinationOff: boolean; bowelMovementOn: boolean; bowelMovementOff: boolean; noVoid: boolean; RecordedDate: string; FormattedDate: string; }[] = [];
  UrinationOn: boolean = false;
  UrinationOff: boolean = false;
  BowelMovementOn: boolean = false;
  BowelMovementOff: boolean = false;
  NoVoid: boolean = false;

  timeOut: any;
  
  isTimeUp: boolean = false;
  remainingTrials: number = 0;

  constructor(
    protected override cdRef: ChangeDetectorRef,
    private patientSessionService: PatientSessionService,
    private alertService: AlertService
  ) {
    super(cdRef);
    effect(() => {
      this.patientSessionService.dataChanged();
      const targetData = this.patientSessionService.getTargetData(this.targetID);
      if (targetData) {
        this.targetData = targetData.filter(t => !t.DeletedDate);
        
        this.remainingTrials = (this.target?.DesiredTrials ?? 0) - this.targetData.length;
        if (this.remainingTrials < 0) {
          this.remainingTrials = 0;
        }

        if (this.target?.TargetStatus === PatientTargetStatus.Mastered || this.target?.TargetStatus === PatientTargetStatus.Closed || this.target?.TargetStatus === PatientTargetStatus.Fluent) {
          this.remainingTrials = 0;
        }   
        this.toiletings = this.targetData.map(t => {
          if (!t.TextValue) {
            t.TextValue = '';
          }
          //parse the totalCorrect and totalIncorrect from the textvalue
          this.UrinationOn = (t.ToiletingData?.UrinationOn ?? false);
          this.UrinationOff = (t.ToiletingData?.UrinationOff ?? false);
          this.BowelMovementOn = (t.ToiletingData?.BowelMovementOn ?? false);
          this.BowelMovementOff = (t.ToiletingData?.BowelMovementOff ?? false);
          this.NoVoid = (t.ToiletingData?.NoVoid ?? false);
          return {
            urinationOn: this.UrinationOn,
            urinationOff: this.UrinationOff,
            bowelMovementOn: this.BowelMovementOn,
            bowelMovementOff: this.BowelMovementOff,
            noVoid: this.NoVoid,
            RecordedDate: t.RecordedDate ?? '',
            FormattedDate: this.formatDate(new Date(t.RecordedDate ?? '')),
          };

        });

      }
      else {
        this.targetData = [];
        this.toiletings = [];
      }
    });

    effect(() => {
      this.patientSessionService.dataChanged();
      const targetsRunningData = this.patientSessionService.getTargetsRunningData(this.patientSessionService.getPatientSession()?.ID ?? -1, this.targetID);
      if (targetsRunningData) {
        const wasStarted = this.isStarted;
        this.isTimeUp = targetsRunningData.Data.isTimeUp;
        this.isStarted = targetsRunningData.Data.isStarted;
        this.startTime = targetsRunningData.Data.startTime;
        this.timerValue = targetsRunningData.Data.timerValue;
        this.UrinationOn = (targetsRunningData.Data.urinationOn ?? false);
        this.UrinationOff = (targetsRunningData.Data.urinationOff ?? false);
        this.BowelMovementOn = (targetsRunningData.Data.bowelMovementOn ?? false);
        this.BowelMovementOff = (targetsRunningData.Data.bowelMovementOff ?? false);
        this.NoVoid = (targetsRunningData.Data.noVoid ?? false);
        if (this.isStarted && !wasStarted) {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
          }
          this.timeOut = setTimeout(() => {
            this.updateTimer();
          }, 10);
        }
      } else {

      }
    });
  }

  ngOnInit() {
    this.text = this.target?.TargetName ?? '-';
    this.targetID = this.target?.ID ?? 0;
    this.expectedAmount = this.target?.DesiredTrials ?? 1;
    this.timerInitialValue = this.target?.Duration ?? 60;
    this.timerValue = this.timerInitialValue;
    this.timerValueInput = this.timerString();
  }

  override doLongPress(): void {
    this.showExtra2();
  }

  clickedBox() {
    if (this.isStarted) {
      this.showExtra();
    }
  }

  startTimer() {
    if (this.isStarted) {
      this.showExtra();
    } else {
      if (this.timerInitialValue > 0) {
        this.isTimeUp = false;
        this.isStarted = true;
        this.startTime = Date.now();
        this.UrinationOn = false;
        this.UrinationOff = false;
        this.BowelMovementOn = false;
        this.BowelMovementOff = false;
        this.NoVoid = false;
        this.updateTimer();
        this.saveTargetRunningData();
      } else {
        this.isTimeUp = true; 
        this.isStarted = true;
        this.startTime = Date.now();
        this.UrinationOn = false;
        this.UrinationOff = false;
        this.BowelMovementOn = false;
        this.BowelMovementOff = false;
        this.NoVoid = false;
        this.updateTimer();
        this.saveTargetRunningData();
      }
    }
  }


  saveTargetRunningData() {
    this.patientSessionService.setTargetsRunningData(this.patientSessionService.getPatientSession()?.ID ?? -1, this.targetID, { isToiletingTarget: true, isTimeUp: this.isTimeUp, timerInitialValue: this.timerInitialValue, isStarted: this.isStarted, startTime: this.startTime, timerValue: this.timerValue, urinationOn: this.UrinationOn, urinationOff: this.UrinationOff, bowelMovementOn: this.BowelMovementOn, bowelMovementOff: this.BowelMovementOff, noVoid: this.NoVoid });
  }

  override ngOnDestroy() {
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }
    super.ngOnDestroy();
  }

  private updateTimer(): void {
    if (this.isStarted) {
      const currentTime = Date.now();

      if (this.isTimeUp) {
        this.timerValue = this.timerInitialValue + Math.floor((currentTime - this.startTime) / 1000);
      } else {
        this.timerValue = this.timerInitialValue - Math.floor((currentTime - this.startTime) / 1000);
      }

      const shouldRingAlarm = !this.isTimeUp && this.timerValue === 0 && 
        (this.target?.AlarmOption === AlarmOption.AlarmAtEnd);

      this.ringAlarmIfNeeded(
        this.target?.AlarmOption ?? AlarmOption.NoAlarm, 
        this.timerValue, 
        this.target?.Duration ?? 0, 
        this.target?.AlarmSoundOption ?? 1,
        false
      );
      
      if (!this.isTimeUp && this.timerValue <= 0) {
        // If alarm should ring, delay the stop to allow alarm to play
        if (shouldRingAlarm) {
          setTimeout(() => {
            this.stopTimer();
          }, 100);
        } else {
          this.stopTimer();
        }
      } else {
        if (this.timeOut) {
          clearTimeout(this.timeOut);
        }
        this.timeOut = setTimeout(() => {
          this.updateTimer();
          this.saveTargetRunningData();
        }, 1000);
      
      }
    }else {
      if (this.timeOut) {
        clearTimeout(this.timeOut);
      }
    }
  }

  stopTimer() {
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }
    this.isStarted = false;
    const currentDate = new Date();
    const formattedDate = this.formatDate(currentDate);
    const duration = this.isTimeUp ? this.timerValue : (this.timerInitialValue-this.timerValue);
    this.patientSessionService.addTargetData({
      IntValue: duration,
      TextValue: duration.toString(),
      PatientTargetID: this.targetID,
      RecordedDate: currentDate.toServerString(),
      ToiletingData: {
        UrinationOn: this.UrinationOn,
        UrinationOff: this.UrinationOff,
        BowelMovementOn: this.BowelMovementOn,
        BowelMovementOff: this.BowelMovementOff,
        NoVoid: this.NoVoid,
        Duration: duration,
      },
    });


    this.timerValue = this.timerInitialValue;
    this.timerValueInput = this.timerString();
    this.UrinationOn = false;
    this.UrinationOff = false;
    this.BowelMovementOn = false;
    this.BowelMovementOff = false;
    this.NoVoid = false;
    this.startTime = Date.now();

    this.saveTargetRunningData();
    this.closeExtra();
    
  }

  timerString() {
    const minutes = Math.floor(this.timerValue / 60);
    const seconds = this.timerValue % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }



  onInputChange(e: any) {
    let value = e.target.value.replace(/\D/g, ''); // Remove non-digit characters
    if (value.length >= 3) {
      value = value.slice(0, 2) + ':' + value.slice(2, 4);
    }
    e.target.value = value;
  }

  changedTimerValue() {
    //parse the value to a number in seconds
    const minutes = this.timerValueInput.split(':')[0]; 
    const seconds = this.timerValueInput.split(':')[1]??0;
    this.timerInitialValue = parseInt(minutes) * 60 + parseInt(seconds);
  }

  
  setUrinationOn(event: any) {
    this.UrinationOn = event.checked;
    this.saveTargetRunningData();
  }

  setUrinationOff(event: any) {
    this.UrinationOff = event.checked;
    this.saveTargetRunningData();
  }

  setBowelMovementOn(event: any) {
    this.BowelMovementOn = event.checked;
    this.saveTargetRunningData();
  }

  setBowelMovementOff(event: any) {
    this.BowelMovementOff = event.checked;
    this.saveTargetRunningData();
  }

  setNoVoid(event: any) {
    this.NoVoid = event.checked;
    this.saveTargetRunningData();
  }

  getToiletingText(toileting: any) {
    return (toileting.urinationOn ? 'Urination On<br>' : '') + 
           (toileting.urinationOff ? 'Urination Off<br>' : '') + 
           (toileting.bowelMovementOn ? 'Bowel On<br>' : '') + 
           (toileting.bowelMovementOff ? 'Bowel Off<br>' : '') + 
           (toileting.noVoid ? 'No Void<br>' : '');
  }

  deleteData(data: any) {
    //confirm the deletion
    const confirmed = this.alertService.confirm('Are you sure you want to delete this data?', 'Delete Data');
    confirmed.subscribe(result => {
      if (result) {
        let targetDataToSave: PatientTargetDataModel | undefined = this.targetData.find(t => t.RecordedDate === data.RecordedDate);
        if (targetDataToSave) {
          targetDataToSave.DeletedDate = new Date().toServerString();
          this.patientSessionService.saveTargetData(targetDataToSave);
        }
      }
    }); 
  }
  
}